/**
 * NIP-PS: Magazines, Magazine Issues & Ebooks
 * Kind definitions for the PressStr client.
 */

/** Kind 34609 — Magazine (Publication) */
export const KIND_MAGAZINE = 34609;

/** Kind 39731 — Magazine Issue */
export const KIND_MAGAZINE_ISSUE = 39731;

/** Kind 33953 — Ebook */
export const KIND_EBOOK = 33953;
